import {Jodit} from "jodit"
import JoditEditor from 'jodit-react';
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { MdOutlineErrorOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { addEmailSignature, deleteEmailSignature, getEmailSignatureList, updateEmailSignature } from '../../utils/awsAPI';
import { FaRegSave, FaTrashAlt, FaRegEdit } from "react-icons/fa"; 


let OptionsJodit = Jodit.defaultOptions

const EmailSignatureSettings = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const timerRef = useRef<any>(null);
    const [signatureName, setSignatureName] = useState<any>("")
    const [signatureNameError, setSignatureNameError] = useState<any>("");
    const [signature, setSignature] = useState<any>("")
    const [signatureError, setSignatureError] = useState<any>("");
    const [signatureList, setSignatureList] = useState<any>("")
    const [selectedSignature, setSelectedSignature] = useState<any>("")
    const [loader, setLoader] = useState<any>(false)
    const [successAlert, setSuccessAlert] = useState(false)
    const [failedAlert, setFailedAlert] = useState(false)
    const [isDisabled, setIsDisabled] = useState<any>(false)
    const [modalShow, setModalShow] = useState(false);

    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    
    useEffect(()=>{
        getEmailSignatureData()
        return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handleClose = () => {
        setSelectedSignature("") 
        setModalShow(false);
    }
    
    const getEmailSignatureData = async () => {
        setLoader(true)
        let username = agentObj.getConfiguration().username;
        let result = await getEmailSignatureList(username)
        if(result.data.body) {
            setSignatureList(result?.data?.body?.Items)
            setLoader(false)
        }
        setLoader(false)
    }

    const onSaveSignature = async() => {
        if(agentObj) {
            if(signatureName === "") {
                setSignatureNameError("Please enter signature name")
                return false;
            } else if(signature === "") {
                setSignatureError("Please enter signature")
                return false;
            }
            
            if (signatureList.length >= 3){
                setSignatureError("Only 3 Signatures are allowed")
                timerRef.current = setTimeout(() => setSignatureError(""), 5000);
                return false;
            }



            setIsDisabled(true)
            let username = agentObj.getConfiguration().username; 
            let result = await addEmailSignature(username,signatureName,signature)
            if(result.success) {
                setSuccessAlert(true)
                setSignatureName("")
                setSignature("")
                getEmailSignatureData()
                timerRef.current = setTimeout(() => setSuccessAlert(false), 5000);

            } else {
                setFailedAlert(true)
                setSignatureName("")
                setSignature("")
                timerRef.current = setTimeout(() => setFailedAlert(false), 5000);
            }
            setSignatureError("")
            setSignatureNameError("")
            setIsDisabled(false)
        }
    }

    const onChangeSignatureName = (event:any) => {
        setSignatureName(event.target.value)
    }

    const onEditSignature = (signatureId:any) => {
        const selectedTemplate = signatureList.filter((item:any) => item.signatureId === signatureId)[0]
        setSelectedSignature(selectedTemplate)
        setSignatureName(selectedTemplate.signatureName)
        setSignature(selectedTemplate.signature)
    }

    const onUpdateSignature = async (signatureId:any) => {
        setIsDisabled(true)
        let result = await updateEmailSignature(signatureId, signature, signatureName)
        if(result.success) {
            setSuccessAlert(true)
            setSelectedSignature("")
            setSignature("")
            setSignatureName("")
            timerRef.current = setTimeout(() => setSuccessAlert(false), 5000);
            getEmailSignatureData()
        } else {
            setFailedAlert(true)
            setSelectedSignature("")
            setSignature("")
            setSignatureName("")
            timerRef.current = setTimeout(() => setFailedAlert(false), 5000);
        }
        setIsDisabled(false)
    }

    const onCancelSignature = () => {
        setSelectedSignature("")
        setSignature("")
        setSignatureName("")
    }

    const onConfirm = (signatureId:any) => {
        const selectedSignature = signatureList.filter((item:any) => item.signatureId === signatureId)[0]
        setSelectedSignature(selectedSignature)
        setModalShow(true)
    }

    const onDeleteSignature = async () => {
        setIsDisabled(true)
        let result = await deleteEmailSignature(selectedSignature.signatureId)
        if(result.success) {
            setSuccessAlert(true)
            setSelectedSignature("")
            timerRef.current = setTimeout(() => setSuccessAlert(false), 5000);
            let newSignature = signatureList.filter((item:any)=> item.signatureId !== selectedSignature.signatureId)
            setSignatureList(newSignature)
            setModalShow(false)
        } else {
            setFailedAlert(true)
            setSelectedSignature("")
            setModalShow(false)
            timerRef.current = setTimeout(() => setFailedAlert(false), 5000);
        }
        setIsDisabled(false)
    }

    return (
        <React.Fragment>
            <Modal show={modalShow} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete?</Modal.Body>
                <Modal.Footer>
                    <Button disabled={isDisabled} variant="primary" onClick={()=>{ onDeleteSignature() }}>
                        {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} Yes
                    </Button>
                    <Button variant="danger" onClick={handleClose}>No</Button>
                </Modal.Footer>
            </Modal>
    <div className="row">
        <div className="col-md-8">
            <div className="card wrapup-box collapse show mt-3" id="widgetSettings">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Email Signature</h6>
                </div>
                <div className="card-body min-height-400">
                    <form>
                        <div className="mb-3 mt-3">
                            {successAlert &&
                                <Alert variant="success" onClose={() => setSuccessAlert(false)} dismissible>
                                    <strong>Data update successfully</strong>
                                </Alert>
                            }
                            {failedAlert &&
                                <Alert variant="success" onClose={() => setFailedAlert(false)} dismissible>
                                    <strong>Failed to update</strong>
                                </Alert>
                            }
                            <label className="form-label">Signature name</label>
                            <input onChange={(event)=>{onChangeSignatureName(event)}} value={signatureName} type="text" className={`form-control form-control-sm ${(signatureNameError !== "")?"is-invalid":""}`} placeholder="Enter signature name" name="signatureName" autoComplete="off"/>
                            {signatureNameError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {signatureNameError} </div>}
                            <label className="form-label mt-3">Signature</label>
                            {/* <textarea onChange={(event) => onSignatureChange(event) } value={signature} className="form-control" rows={7}></textarea> */}
                            <JoditEditor
                                value={signature}
                                config = {OptionsJodit}
                                onBlur={newSignature => setSignature(newSignature)} // preferred to use only this option to update the content for performance reasons
                                onChange={newSignature => {}}
                            />
                            {signatureError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {signatureError} </div>}
                        </div>
                        {!selectedSignature &&
                        <button disabled={isDisabled}  onClick={(event) => onSaveSignature()} type="button" className="btn btn-primary">
                            {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} <FaRegSave /> Save
                        </button>
                        }
                        {selectedSignature &&
                            <span>
                                <button onClick={(event) => onUpdateSignature(selectedSignature.signatureId)} type="button" className="btn btn-warning Signature">
                                    {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} Update
                                </button>
                                <button onClick={(event) => onCancelSignature()} type="button" className="btn btn-danger Signature">Cancel</button>
                            </span>
                        }
                    </form>
                    
                </div>
            </div>
        </div>
        <div className="col-md-4">
            <div className="card wrapup-box collapse show mt-3" id="widgetSettings">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>{"Signatures " + signatureList.length + "/3"}</h6>
                </div>
                <div className="card-body min-height-400">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Signature name</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {loader && <Spinner animation="border" variant="primary" />}
                        {(!loader && signatureList !=='') && signatureList.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <th scope="row" >{index+1}</th>
                                    <td>{item.signatureName}</td>
                                    <td>
                                        <button onClick={(event) => onEditSignature(item.signatureId)} type="button" className="btn-none text-primary"><FaRegEdit /></button>
                                        <button onClick={(event) => onConfirm(item.signatureId)} type="button" className="btn-none text-danger"><FaTrashAlt /></button>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
        </React.Fragment>      
    )
}
export default EmailSignatureSettings;
